<template lang="pug">
  v-card-text
    .text-h6 Урок
    .mb-5.mt-2
    p.mb-4 {{ lesson.name }}
    .d-flex.mb-3
      v-icon.pr-3 mdi-calendar
      .line-height-1
        .pb-3
          span {{ lesson.date_start | dateprint_string }}
          .caption  Начало урока
        .pb-1
          span {{ lesson.date_end | dateprint_string }}
          .caption  Окончание урока
    copy-clipboard-field(
      v-if="meeting.join_url"
      :value="meeting.join_url"
      label="Ссылка на трансляцию"
    )
</template>

<script>
export default {
  props: {
    lesson: {
      type: Object,
      required: true,
    },
    meeting: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.line-height-1 {
  line-height: 1;
}
</style>
